module.exports = __webpack_public_path__ + "static/logo-nav-6e22bc0861a815d20fda24919251f5dd.png";